import React from "react";
import { Autocomplete, TextField, AutocompleteProps, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { RootState } from "../store/store"; 
import { StyledInputLabel } from "../modules/fiscalUpgrade/StyledComponents/Container";

interface StyledProps {
  readOnly?: boolean;
  themeDetails?: any;
}

export const InputForAutocomplete = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'readOnly' && prop !== 'themeDetails',
})<StyledProps>(({ theme, themeDetails, error, readOnly }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-root": {
    backgroundColor: readOnly ? "#F5F5F5" : "#FFFFFF",
    borderRadius: "5px",
    cursor: readOnly ? "not-allowed" : "text",
  },
  "& .MuiInputBase-input": {
    fontSize: "17.67px",
    fontWeight: 400,
    color: readOnly ? "#9E9E9E" : "#2C2222",
    letterSpacing: "0.27px",
    height: "23.5px",
    fontFamily: ["Inter", "sans-serif"],
  },
}));

interface CustomAutocompleteProps extends Omit<AutocompleteProps<any, boolean, boolean, boolean>, 'renderInput'> {
  placeholder?: string;
  error?: boolean;
  label?: string;
  helperText?: string;
  readOnly?: boolean;
  labelText?: string;
  required?: boolean;
  disableClearable?: boolean; 
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  placeholder,
  label,
  error,
  helperText,
  readOnly = false,
  labelText,
  required = false,
  disableClearable = false,
  ...props
}) => {
  const themeDetails = useSelector((state: RootState) => state?.themes);

  return (
    <Box>
      {labelText && (
        <StyledInputLabel shrink>
          {labelText} {required && <span style={{ color: "red" }}>*</span>}
        </StyledInputLabel>
      )}
      <Autocomplete
        {...props}
        disableClearable={disableClearable}
        readOnly={readOnly}
        onOpen={(e) => {
          if (readOnly) {
            e.stopPropagation();
          } else {
            props.onOpen?.(e);
          }
        }}
        renderInput={(params) => (
          <InputForAutocomplete
            {...params}
            size='small'
            placeholder={placeholder}
            label={label}
            error={error}
            helperText={helperText}
            inputProps={{
              ...params.inputProps,
              readOnly: readOnly,
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: readOnly ? null : params.InputProps?.endAdornment,
            }}
            readOnly={readOnly}  
          />
        )}
      />
    </Box>
  );
};

export default CustomAutocomplete;
